import { render, staticRenderFns } from "./comp-option.vue?vue&type=template&id=d6aff294"
import script from "./comp-option.vue?vue&type=script&lang=js"
export * from "./comp-option.vue?vue&type=script&lang=js"
import style0 from "./comp-option.vue?vue&type=style&index=0&id=d6aff294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports